/*
 * @CopyRight    : 广州仰望星空云科技有限公司
 * @Author       : Kyle
 * @Email        : linyukai@xinyu668.com
 * @CreateTime   : 2023-08-14 17:17:01
 * @Description  : 解析服务端返回相关url
 */
import { typeIs, validate } from '@ywxk/util/validate'
import { localCache } from '@ywxk/util/localCache'
import { constConf } from '@GLOBAL/constConf'
import { client } from '@UTILS/client'

const { API_URL, SERVER_ORIGIN, ORIGIN_ENV_PROJECT_ASSETS, IS_PROD, IS_GRAY } = constConf
const { isPC } = client

export const defLogo = `${ORIGIN_ENV_PROJECT_ASSETS}/img/logo.png`
export const defAvatar = `${ORIGIN_ENV_PROJECT_ASSETS}/img/public_pic_avatar.png`
export const defEmpty = `${ORIGIN_ENV_PROJECT_ASSETS}/img/empty.png`
export const defGuide = `${ORIGIN_ENV_PROJECT_ASSETS}/img/guide.png`
export const defAndroid = `${ORIGIN_ENV_PROJECT_ASSETS}/img/android.png`
export const defIos = `${ORIGIN_ENV_PROJECT_ASSETS}/img/ios.png`

// <===================================== 判断浏览器是否支持webp ======================================
export let isSupportWebp = false
export let isSupportAvif: any = false
function check_webp_feature(feature) {
  return new Promise((resolve, reject) => {
    var kTestImages = {
      lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
      lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
      alpha: 'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
      animation: 'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA',
    }
    var img = new Image()
    img.onload = function () {
      var result = img.width > 0 && img.height > 0
      return resolve([feature, result])
    }
    img.onerror = function () {
      return reject([feature, false])
    }
    img.src = 'data:image/webp;base64,' + kTestImages[feature]
  })
}
function check_avif_feature() {
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = () => {
      var result = img.width > 0 && img.height > 0
      resolve(result)
    }
    img.onerror = () => resolve(false)
    img.src =
      'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A='
  })
}
;(async function () {
  const featureKey = 'browser-webp-isSupported'
  const featureKey2 = 'browser-avif-isSupported'
  if (Number(localCache.getItem(featureKey)) === 1) {
    isSupportWebp = true
  } else {
    try {
      const [_, isSupported] = await check_webp_feature('lossy')
      if (isSupported) localCache.setItem(featureKey, '1')
      isSupportWebp = isSupported
    } catch (error) {}
  }

  if (Number(localCache.getItem(featureKey2)) === 1) {
    isSupportAvif = true
  } else {
    try {
      const isSupportedAvif = await check_avif_feature()
      if (isSupportedAvif) localCache.setItem(featureKey2, '1')
      isSupportAvif = isSupportedAvif
    } catch (error) {}
  }
})()
// ====================================== 判断浏览器是否支持webp =====================================>

/**
 * 返回对应dpr像素值
 * @param {number} px
 * @returns number
 */
export function getRealpx(px) {
  const dpr = (window as any).devicePixelRatio
  if (!dpr) return px
  return parseInt((px / 2) * dpr + '') * (isPC ? 2 : 1)
}

/**
 * 用在业务本地图片判断能否转webp,默认进来肯定是图片资源,否则出错
 * @param src
 * @returns
 */
export function localPicAnalysis(src) {
  /*
    支持webp
    指定后缀
    没经过oss参数参数
    非static/apng路径资源
  */
  if (/\.(jpg|png)$/i.test(src) && src.indexOf('x-oss-process') === -1 && src.indexOf('/static/apng/') === -1) {
    const symbol = src.indexOf('?') === -1 ? '?' : '&'
    if (isSupportAvif) {
      return src + symbol + 'x-oss-process=image/format,avif'
    } else if (isSupportWebp) {
      return src + symbol + 'x-oss-process=image/format,webp'
    }
  }
  return src
}
/**
 * 用在将图片格式为heif,heic转换为png, 以便正常显示
 * @param url
 * @returns
 */
export function heicToNormal(url) {
  if (/\.(heic|heif)$/i.test(url)) {
    const symbol = url.indexOf('?') === -1 ? '?' : '&'
    if (isSupportAvif) {
      return url + symbol + 'x-oss-process=image/format,avif'
    } else if (isSupportWebp) {
      return url + symbol + 'x-oss-process=image/format,webp'
    } else {
      return url + symbol + 'x-oss-process=image/format,png'
    }
  }
  return url
}
/**
 * 解析资源地址,(Apng不能转webp,会变成静态资源)
 * @param {*} options
 * {
 *  domain: 拼接域名
 *  isOptimize: 是否使用oss处理
 *  width: 宽度 按规定入参修正,或者使用原尺寸
 *  icon: 图片地址
 * }
 * @returns
 */
export function picAnalysis(options) {
  if (!options) return options
  // 格式处理
  if (typeIs('String', options)) options = { icon: options }
  // 空或dataurl格式直接中断返回
  if (!options.icon || validate('dataUrl', options)) return options.icon
  // 替换默认头像
  if (/^[0-9]*$/gi.test(options.icon)) options.icon = defAvatar

  // 合并参数
  const opts = {
    domain: API_URL,
    isOptimize: true,
    ...options,
    // 分辨率计算
    width: getRealpx(options.width || 0),
  }

  /*
    支持优化
    指定后缀
    非static/apng路径资源
  */
  if (opts.isOptimize && validate('img', opts.icon) && opts.icon.indexOf('/apng/') === -1) {
  const symbol = opts.icon.indexOf('?') === -1 ? '?' : '&'
    opts.icon += `${symbol}x-oss-process=image${opts.width ? `/resize,m_lfit,w_${opts.width}` : ''}${isSupportAvif && opts.icon.indexOf('.gif') === -1 ? '/format,avif' : isSupportWebp ? '/format,webp' : ''}`
  }

  // 完整路径直接返回
  if (opts.icon.indexOf('http') !== -1) return opts.icon

  // 兼容后端返回webp格式
  if (opts.icon.indexOf('.webp') > -1 && !isSupportWebp) opts.icon = `${opts.icon}?x-oss-process=image/format,png`
  // 判断新旧解析的标准
  const apiPic = `${opts.domain}/${opts.icon}`
  const ossPic = `${SERVER_ORIGIN}/${opts.icon}`

  if (/^\/?upload\//g.test(opts.icon) || /\/kefu_avatar\//g.test(opts.icon) || /\/im\//g.test(opts.icon)) {
    // if ((IS_PROD || IS_GRAY) || /(beta|alpha|pre|aut|prod)/g.test(opts.icon)) return ossPic
    // return apiPic
    return ossPic
  } else {
    if (/^\/?(beta|alpha|pre|aut|prod)\/resources\//g.test(opts.icon)) {
      // if (!(IS_PROD || IS_GRAY) && !/(beta|alpha|pre|aut)\//g.test(opts.icon)) return apiPic
      return ossPic
    } else if (/^\/?(beta|alpha|pre|aut|prod)\/trend\//g.test(opts.icon)) {
      // if (!(IS_PROD || IS_GRAY) && !/(beta|alpha|pre|aut)\//g.test(opts.icon)) return apiPic
      return ossPic
    } else {
      // 解析图片路径,Icon为需要解析的Icon，idx为0和1，代表不同尺寸的图片，一般头像都用0
      return `${opts.domain}/upload/icon/${opts.icon.substring(0, 2)}/${opts.icon.substring(0, 4)}/${opts.icon}_0.jpg`
    }
  }
}
